import { environment } from './environment';
import { mapping } from './environment-mapping.const';

export const HostGetter = {
    getHost() {
        if (location.host.includes('localhost:')) {
            const host = window.localStorage.getItem('portalLocalhost');

            if (host) { return host.trim(); }
        }

        return location.host;
    }
};

export const loadEnvironmentFactory = () => {

    return () => {
        return new Promise((resolve) => {
            const runtimeEnvironment = mapping[HostGetter.getHost()];
            if (!runtimeEnvironment) {
                throw new Error('Environment not found');
            }
            Object.assign(environment, runtimeEnvironment);
            resolve();
        });
    };
};
